import {
    GET_SELECTED_ACTION_SOCIALE,
    GET_ALL_ACTION_SOCIALE, GET_SELECTED_EXERCICE, GET_FICHE,
    GET_OPT_JUSTIFICATIF, GET_MAX_VAL_PRESTATION, GET_IBAN,
    GET_PAC, GET_FULL_ACTION_SOCIALE,GET_PARAMS_ENFANT,GET_CESU_MULTI_TAUX
} from "../actions/types";

const actionSociale = JSON.parse(localStorage.getItem("actionSociale"));

const initialState = {
    cas: actionSociale?.cas ? actionSociale.cas : '',
    exercice: actionSociale?.exercice ? actionSociale.exercice : '',
    fiche: actionSociale?.fiche ? actionSociale.fiche : '',
    optJustificatif: actionSociale?.optJustificatif ? actionSociale.optJustificatif : '',
    iban: actionSociale?.iban ? actionSociale.iban : '',
    maxVal: actionSociale?.maxVal ? actionSociale.maxVal : 0,
    enfants: actionSociale?.enfants ? actionSociale.enfants : [],
    listActionsSociale: actionSociale?.listeActionsSociale ? actionSociale.listeActionsSociale : [],
    paramsEnfants:actionSociale?.paramsEnfants ? actionSociale.paramsEnfants : '',
    cesuMultiTaux:actionSociale?.cesuMultiTaux ? actionSociale.cesuMultiTaux : '',
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_SELECTED_ACTION_SOCIALE:
            return {
                ...state,
                cas: payload.cas,
                exercice: '',
                fiche: '',
                optJustificatif: '',
                iban: '',
                maxVal: 0,
                enfants: [],
                listActionsSociale: state.listActionsSociale,
                paramsEnfants:state.paramsEnfants
            };
        case GET_SELECTED_EXERCICE:
            return {
                ...state,
                cas: state.cas,
                exercice: payload.exercice,
                fiche: '',
                optJustificatif: '',
                iban: '',
                maxVal: 0,
                enfants: [],
                listActionsSociale: state.listActionsSociale,
                paramsEnfants:state.paramsEnfants
            };
        case GET_FICHE:
            return {
                ...state,
                cas: state.cas,
                exercice: state.exercice,
                fiche: payload.fiche,
                optJustificatif: '',
                iban: '',
                maxVal: 0,
                enfants: [],
                listActionsSociale: state.listActionsSociale,
                paramsEnfants:state.paramsEnfants
            };
        case GET_OPT_JUSTIFICATIF:
            return {
                ...state,
                cas: state.cas,
                exercice: state.exercice,
                fiche: state.fiche,
                optJustificatif: payload.optJustificatif,
                iban: state.iban,
                maxVal: state.maxVal,
                enfants: state.enfants,
                listActionsSociale: state.listActionsSociale,
                paramsEnfants:state.paramsEnfants
            };
        case GET_IBAN:
            return {
                ...state,
                cas: state.cas,
                exercice: state.exercice,
                fiche: state.fiche,
                optJustificatif: state.optJustificatif,
                iban: payload.iban,
                maxVal: state.maxVal,
                enfants: state.enfants,
                listActionsSociale: state.listActionsSociale,
                paramsEnfants:state.paramsEnfants
            };
        case GET_MAX_VAL_PRESTATION:
            return {
                ...state,
                cas: state.cas,
                exercice: state.exercice,
                fiche: state.fiche,
                optJustificatif: state.optJustificatif,
                iban: state.iban,
                maxVal: payload.maxVal,
                enfants: state.enfants,
                listActionsSociale: state.listActionsSociale,
                paramsEnfants:state.paramsEnfants
            };
        case GET_PAC:
            return {
                ...state,
                cas: state.cas,
                exercice: state.exercice,
                fiche: state.fiche,
                optJustificatif: state.optJustificatif,
                iban: state.iban,
                maxVal: state.maxVal,
                enfants: payload.enfants,
                listActionsSociale: state.listActionsSociale,
                paramsEnfants:state.paramsEnfants
            };
        case GET_ALL_ACTION_SOCIALE:
            return {
                ...state,
                cas: state.cas,
                exercice: state.exercice,
                fiche: state.fiche,
                optJustificatif: state.optJustificatif,
                iban: state.iban,
                maxVal: state.maxVal,
                enfants: state.enfants,
                listActionsSociale: payload.listActionsSociale,
                paramsEnfants:state.paramsEnfants
            };
        case GET_FULL_ACTION_SOCIALE:
            return {
                ...state,
                cas: payload.actionSociale.cas,
                exercice: payload.actionSociale.exercice,
                fiche: payload.actionSociale.fiche,
                optJustificatif: payload.actionSociale.optJustificatif,
                iban: payload.actionSociale.iban,
                maxVal: payload.actionSociale.maxVal,
                enfants: payload.actionSociale.enfants,
                listActionsSociale: payload.actionSociale.listActionsSociale,
                paramsEnfants:payload.paramsEnfants
            };
        case GET_PARAMS_ENFANT:
                    return {
                        ...state,
                        cas: state.cas,
                        exercice: state.exercice,
                        fiche: state.fiche,
                        optJustificatif: state.optJustificatif,
                        iban: state.iban,
                        maxVal: state.maxVal,
                        enfants: state.enfants,
                        listActionsSociale: state.listActionsSociale,
                        paramsEnfants:payload.paramsEnfants
                    };
         case GET_CESU_MULTI_TAUX:
                        return {
                            ...state,
                            cas: state.cas,
                            exercice: state.exercice,
                            fiche: state.fiche,
                            optJustificatif: state.optJustificatif,
                            iban: state.iban,
                            maxVal: state.maxVal,
                            enfants: state.enfants,
                            listActionsSociale: state.listActionsSociale,
                            paramsEnfants:state.paramsEnfants,
                            cesuMultiTaux:payload.cesuMultiTaux
                        };            
        default:
            return state;
    }
}


